import { __assign } from "tslib";
import React, { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { BiData } from '@wix/da-bi/pkg/events';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Add from '@wix/da-ds/pkg/Icons/16x16/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NativeDropdown from '../../../../../Dropdown/NativeDropdown';
import StandardDropdownMenu from '../../../../../Dropdown/Preset/StandardDropdown/StandardDropdownMenu';
import { PopperDropdownManager, PopperDropdownToggle, } from '../../../../../Dropdown/PopperDropdownLayout';
import s from './MoreSuggestionsDropdown.scss';
var MoreSuggestionsDropdown = function (_a) {
    var items = _a.items, onSelect = _a.onSelect, commonBiData = _a.commonBiData, buttonClassName = _a.buttonClassName;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var logBiEvent = useBiLogger();
    var onDropdownClose = useCallback(function () {
        logBiEvent(BiData(__assign({ evid: 192, is_displayed: 0 }, commonBiData)));
    }, [logBiEvent, commonBiData]);
    if (isMobile) {
        return (React.createElement("div", { className: s['root'] },
            React.createElement(PlainButtonOrLink, { className: cn(buttonClassName, s['more']) },
                React.createElement(Add, { size: IconSize.SMALLER, disableDefaultColors: true })),
            React.createElement(NativeDropdown, { className: s['dropdown'], items: items, onSelect: onSelect })));
    }
    return (React.createElement(PopperDropdownManager, { onClose: onDropdownClose },
        React.createElement(PopperDropdownToggle, { className: cn(buttonClassName, s['more']), "aria-owns": "commentbox-suggestions-menu", "aria-label": t('common.more'), onOpenBiData: BiData(__assign({ evid: 192, is_displayed: 1 }, commonBiData)), onCloseBiData: BiData(__assign({ evid: 192, is_displayed: 0 }, commonBiData)) },
            React.createElement(Add, { size: IconSize.SMALLER, disableDefaultColors: true })),
        React.createElement(StandardDropdownMenu, { id: "commentbox-suggestions-menu", items: items, role: "menu", menuClassName: s['menu'], menuScrollable: true, onSelect: onSelect })));
};
MoreSuggestionsDropdown.displayName = 'MoreSuggestionsDropdown';
export default MoreSuggestionsDropdown;
//# sourceMappingURL=MoreSuggestionsDropdown.js.map